
<template>
  <div>
    <v-card>
      <v-card-text>
        <EmployeeInfoForm ref="form" :user_attributes="employee.user_attributes" :teamModel="employee"></EmployeeInfoForm>
      </v-card-text>
      <v-card-actions>
        <v-btn text disabled>
          <v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon>
        </v-btn>
        <v-btn text @click="emitChangeStepper(true)">
          <v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"

export default {
  name: 'EmployeeInfoStepper',
  mixins: [validations],
  props:{
    employee: {
      type: Object,
      default: () => { return {} }
    }
  },
  components:{
    EmployeeInfoForm: () => import("@/_backoffice/_registrations/components/employee/forms/EmployeeInfoForm.vue")
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
    emitChangeStepper(increment){
      this.prepareInfo()
      this.$emit("changeStepper", increment)
    },
    
    prepareInfo() {
      this.employee.accounts.primary.titular = this.employee.user_attributes.name;
      this.employee.accounts.primary.titularCPF = this.employee.user_attributes.cpf;
    },
  },
}
</script>
